// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__2njQm","svgCircle":"Card_svgCircle__1mzSR","text":"Card_text__3mWTK"};